import React, { useEffect, useState } from 'react';
import { getdata, getdatanoauth, WAITINGGIF, sendwhatsappmessageapi } from '../../util/global';
import TableAmazonOrder from './TableAmazonOrder';
import KitLoader from '../../components/kitsters/KitLoader';

const AmazonOrderCheck = () => {
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const params = new URLSearchParams(window.location.search);



  const fetchdata = async () => {
    const adminuserid = window.APPUSER?.user?.token ? window.APPSETTING.adminuserid : params.get('adminuserid');

    let res = await getdatanoauth({ datatype: 'amazonorders', _adminuserid: adminuserid }, '/amazonordercheck');
    setdata(res.data);
    setLoading(false);
  };


  useEffect(() => {
    fetchdata();
  }, []);

  return (
    <div className="content-area" style={{ position: 'relative', minHeight: 'calc(100vh - 140px)' }}>
      {loading && <KitLoader />}
      <h3 style={{ marginBottom: '16px' }}>Amazon Orders Not in Zoho | Problem Count: {data.length}  </h3>
      <TableAmazonOrder rows={data} />
    </div>
  );
};

export default AmazonOrderCheck;
